(() => {
  const slugify = (text) => {
    return text
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\u4e00-\u9fff-]+/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  };

  const buildFaq = (content) => {
    content.querySelectorAll('h2').forEach((heading) => {
      if (heading.textContent.trim().toUpperCase() !== 'FAQ') return;

      const nodes = [];
      let sibling = heading.nextElementSibling;
      while (sibling && sibling.tagName !== 'H2') {
        nodes.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      if (!nodes.some((node) => node.tagName === 'H3')) return;

      const list = document.createElement('div');
      list.className = 'article-faq-list';
      heading.insertAdjacentElement('afterend', list);

      let answer;
      let count = 0;
      nodes.forEach((node) => {
        if (node.tagName === 'H3') {
          count += 1;
          const item = document.createElement('details');
          const summary = document.createElement('summary');
          const index = document.createElement('span');
          const icon = document.createElement('span');
          answer = document.createElement('div');

          item.className = 'article-faq-item';
          summary.className = 'article-faq-question';
          index.className = 'article-faq-index';
          index.textContent = String(count).padStart(2, '0');
          node.classList.add('article-faq-title');
          icon.className = 'article-faq-toggle-icon';
          icon.setAttribute('aria-hidden', 'true');
          answer.className = 'article-faq-answer';

          summary.append(index, node, icon);
          item.append(summary, answer);
          list.appendChild(item);
        } else if (answer) {
          answer.appendChild(node);
        } else {
          list.appendChild(node);
        }
      });
    });
  };

  const showRelatedPosts = (article) => {
    const related = article.querySelector('[data-related-posts]');
    if (!related) return;

    const cards = Array.from(related.querySelectorAll('[data-related-card]'));
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
    }

    cards.slice(0, 3).forEach((card) => {
      card.hidden = false;
      related.querySelector('.article-template__related-list').appendChild(card);
    });
  };

  const initArticleToc = (root) => {
    if (!root || root.dataset.articleTocReady === 'true') return;

    const article = root.closest('.article-template--toc');
    const content = article && article.querySelector('[data-article-content]');
    const intro = article && article.querySelector('[data-article-intro]');
    const list = root.querySelector('[data-toc-list]');
    const marker = root.querySelector('[data-toc-marker]');
    if (!article || !content || !list) return;
    if (!article || !content || !intro || !list) return;

    root.dataset.articleTocReady = 'true';

    for (const node of Array.from(content.childNodes)) {
      if (node.nodeType === 1 && (node.tagName === 'H2' || node.querySelector('h2'))) break;
      intro.appendChild(node);
    }
    intro.hidden = !intro.textContent.trim() && !intro.querySelector('img, video, iframe, table');

    showRelatedPosts(article);

    buildFaq(content);

    const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => {
      return heading.textContent.trim().length > 0;
    });

    if (!headings.length) {
      root.classList.add('is-empty');
      article.classList.add('article-template--toc-empty');
      return;
    }

    const usedIds = new Set();
    document.querySelectorAll('[id]').forEach((element) => {
      if (!headings.includes(element)) usedIds.add(element.id);
    });

    headings.forEach((heading, index) => {
      if (heading.id) {
        usedIds.add(heading.id);
        return;
      }

      const baseId = slugify(heading.textContent) || `section-${index + 1}`;
      let id = baseId;
      let suffix = 2;

      while (usedIds.has(id)) {
        id = `${baseId}-${suffix}`;
        suffix += 1;
      }

      heading.id = id;
      usedIds.add(id);
    });

    headings.forEach((heading) => {
      const item = document.createElement('li');
      const link = document.createElement('a');

      item.className = 'article-template__toc-item';
      link.className = 'article-template__toc-link';
      link.href = `#${heading.id}`;
      link.dataset.tocTarget = heading.id;
      link.textContent = heading.textContent.trim();

      item.appendChild(link);
      list.appendChild(item);
    });

    const links = Array.from(list.querySelectorAll('[data-toc-target]'));

    const moveMarker = (link) => {
      if (!marker || !link) return;

      const item = link.closest('.article-template__toc-item');
      if (!item || item.offsetParent === null) return;

      marker.style.height = `${Math.max(link.offsetHeight, 22)}px`;
      marker.style.transform = `translateY(${item.offsetTop}px)`;
    };

    const setActive = (id) => {
      const activeLink = links.find((link) => link.dataset.tocTarget === id);

      links.forEach((link) => {
        const isActive = link === activeLink;
        link.classList.toggle('is-active', isActive);
        link.toggleAttribute('aria-current', isActive);
      });

      moveMarker(activeLink);
    };

    let ticking = false;

    const updateActiveHeading = () => {
      ticking = false;

      const offset = 120;
      let activeHeading = headings[0];

      headings.forEach((heading) => {
        if (heading.getBoundingClientRect().top <= offset) {
          activeHeading = heading;
        }
      });

      setActive(activeHeading.id);
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActiveHeading);
    };

    links.forEach((link) => {
      link.addEventListener('click', () => {
        setActive(link.dataset.tocTarget);
      });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    setActive(headings[0].id);
    requestUpdate();
  };

  const initAllArticleTocs = (scope = document) => {
    scope.querySelectorAll('[data-article-toc]').forEach(initArticleToc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllArticleTocs());
  } else {
    initAllArticleTocs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllArticleTocs(event.target);
  });
})();